var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _c('hr'), _c('p', {
    staticClass: "mt-4 mb-4 sub-text"
  }, [_vm._v(" Sin duda alguna, los Funko Pop más buscados no se limitan a estos pocos, pero si podemos decir que estos en concreto se han ganado a pulso el corazón de todos los fanáticos y fanáticas de los Funko Pop y de las series y películas más conocidas. Echa un vistazo a todos los Funko Pop que puedas encontrarte y escoge por ti mismo cual debería ser el que adorne tu estantería, y nada mejor para encontrarlo que haciendo uso de la nuestra tienda online referente de Funkos. ")]), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "Harry Potter",
      "img-src": require("@/assets/img/harry.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.my-modal",
      modifiers: {
        "my-modal": true
      }
    }],
    staticClass: "btn-funko-primary"
  }, [_vm._v("Más detalles")]), _c('b-modal', {
    attrs: {
      "id": "my-modal"
    }
  }, [_vm._v("Es protagonista de una serie de novelas fantásticas escrita por la autora británica J. K. Rowling, en la que se describen las aventuras del joven aprendiz de magia y hechicería Harry Potter y sus amigos")])], 1)])], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "Iron Man",
      "img-src": require("@/assets/img/star.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.my-modal2",
      modifiers: {
        "my-modal2": true
      }
    }],
    staticClass: "btn-funko-primary"
  }, [_vm._v("Más detalles")]), _c('b-modal', {
    attrs: {
      "id": "my-modal2"
    }
  }, [_vm._v("Iron Man es un superhéroe que aparece en los cómics estadounidenses publicados por Marvel Comics. El personaje fue cocreado por el escritor y editor Stan Lee")])], 1)])], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "Batman",
      "img-src": require("@/assets/img/batman.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.my-modal3",
      modifiers: {
        "my-modal3": true
      }
    }],
    staticClass: "btn-funko-primary"
  }, [_vm._v("Más detalles")]), _c('b-modal', {
    attrs: {
      "id": "my-modal3"
    }
  }, [_vm._v("Conocido inicialmente como Bat-Man y en español como el Hombre Murciélago, es un personaje de cómic lucha por la justicia y es propiedad de DC Comics.")])], 1)])], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "Daenerys y Drogon",
      "img-src": require("@/assets/img/tron.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.my-modal4",
      modifiers: {
        "my-modal4": true
      }
    }],
    staticClass: "btn-funko-primary"
  }, [_vm._v("Más detalles")]), _c('b-modal', {
    attrs: {
      "id": "my-modal4"
    }
  }, [_vm._v("La reina Daenerys Targaryen, también llamada Daenerys de la Tormenta, Rompedora de Cadenas, Madre de Dragones, acompañada de Drogon que es uno de sus leales dragones.")])], 1)])], 1), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-4"
  }, [_c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "title": "Ned Flanders Demonio",
      "img-src": require("@/assets/img/flanders.png"),
      "img-alt": "Image",
      "img-top": "",
      "tag": "article"
    }
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.my-modal5",
      modifiers: {
        "my-modal5": true
      }
    }],
    staticClass: "btn-funko-primary"
  }, [_vm._v("Más detalles")]), _c('b-modal', {
    attrs: {
      "id": "my-modal5"
    }
  }, [_vm._v("Nedward Flanders, más conocido como Ned, es un personaje ficticio de la serie de televisión de dibujos animados Los Simpson. Es reconocido por ser el buen vecino de Homero.")])], 1)])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "funko-home-title mt-5"
  }, [_vm._v("FUNKOS MAS BUSCADOS")])]);
}]

export { render, staticRenderFns }